interface CityForCitySlug {
  id: number;
  cachedSlug: string;
}

export const determineCitySlug = (
  lastViewedCity?: CityForCitySlug,
  closestCity?: CityForCitySlug
) => {
  const isCityOrEventPage =
    window.location.pathname.includes('/cities/') ||
    window.location.pathname.includes('/events/');

  return isCityOrEventPage
    ? lastViewedCity?.cachedSlug
    : closestCity?.cachedSlug;
};
